module.exports = __WEBPACK_EXTERNAL_MODULE_229__;


//////////////////
// WEBPACK FOOTER
// external "gemini/api/impl/Dashboard"
// module id = 229
// module chunks = 0